import script from "./FileConstruction.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileConstruction.vue?vue&type=script&lang=ts&setup=true"

import "./FileConstruction.vue?vue&type=style&index=0&id=72cb6bf0&lang=css"

const __exports__ = script;

export default __exports__